import { isValidElement } from "react";

import { styled } from "styled-components";

import type { StrictColor } from "@similarweb/styles";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import type { PopTooltipCellProps } from "./types";

export const PopTooltipContainer = styled.div`
    display: grid;
    grid-template-columns: 1.2fr repeat(3, 1fr);
    grid-template-rows: auto 1px auto;
    column-gap: 4px;
    row-gap: 4px;
    padding: 4px;
    width: 300px;
`;

export const PopTooltipDivider = styled.div`
    grid-column: 1 / -1;
    grid-row: 2;
    background: ${colorsPalettes.carbon[100]};
    height: 100%;
`;

export const PopTooltipHeaderCell = ({ color, children }: PopTooltipCellProps) => (
    <Flex
        justifyContent="flex-end"
        alignContent="center"
    >
        <Text
            fontVariant="subtitle2"
            color={color as StrictColor}
        >
            {children}
        </Text>
    </Flex>
);

export const PopTooltipValueCell = ({ children, color, justifyContent = "flex-end" }: PopTooltipCellProps) => {
    // If children is already a React element (e.g. ChangeValue), render it directly;
    // otherwise wrap raw text in a styled Text component.
    const content = isValidElement(children) ? (
        children
    ) : (
        <Text
            fontVariant="tooltip"
            color={(color ?? colorsPalettes.carbon[200]) as StrictColor}
        >
            {children}
        </Text>
    );

    return (
        <Flex
            justifyContent={justifyContent}
            alignContent="center"
        >
            {content}
        </Flex>
    );
};
